import { render } from "./transfer.vue?vue&type=template&id=3cfb94f3"
import script from "./transfer.js?vue&type=script&lang=js&external"
export * from "./transfer.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__